import { ValidationError, setLocale, ObjectSchema, Schema, StringSchema } from 'yup';
import { locale } from './yup-locale';
setLocale(locale);

import { mapErrors, getValidationErrors } from './custom-functions';
import './custom-method';
import {
    alarmSettingValidator,
    AlarmSettingValidationField,
} from './alarm-settings/alarm-setting-validator';
import { channelValidator, scaleErrorValues } from './channel/channel-validator';
import { trendGraphViewValidator } from './trend-graph/trend-graph-view-validator';
import { dashboardViewValidator } from './dashboard-view.validator';
import { passwordValidate } from './password/password.validator';
import {
    CustomGroupUpdateValidator,
    CustomGroupValidator,
} from './custom-group/custom-group-validator';

export {
    ObjectSchema,
    Schema,
    StringSchema,
    ValidationError,
    AlarmSettingValidationField,
    getValidationErrors,
    alarmSettingValidator,
    scaleErrorValues,
    channelValidator,
    mapErrors,
    trendGraphViewValidator,
    dashboardViewValidator,
    CustomGroupUpdateValidator,
    CustomGroupValidator,
    passwordValidate,
};
